import axios from 'axios'

export default {
    getCategories() {
        return axios.get('/api/categories')
    },

    create(data) {
        return axios.post('/channels/create', {
            name: data.name,
            level: data.level,
            question_group_id: data.category,
            number_of_participants: data.numberOfPlayers,
            type: data.gameType,
            rules: data.rules,
            game_time: data.timeLimit,
            game_limit: data.gameLimit,
            password: data.password
        })
    },
}
